import api from "./api.js";

export default class MemberMerchApi {
  static async getList(data) {
    return await api.get(`api/member-merch`, data);
  }
}
